import serverCrypto from 'crypto';
import { PHONE_NUMBER_REGEX } from '../enum/Constants';
export const isFromNext = (url = '') => {
    return url.startsWith('/_next');
};
export const getHash = (length = 10) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        result += characters.charAt(getRandom(characters.length));
    }
    return result;
};
export const formatTime = (time) => {
    if (time <= 0)
        return '00:00';
    const roundedTime = Math.round(time);
    const minutes = Math.floor(roundedTime / 60);
    const seconds = `${roundedTime % 60}`;
    return `${minutes}:${seconds.padStart(2, '0')}`;
};
export const formatCount = (count) => {
    const units = ['', '만', '억', '조'];
    const str = `${count}`;
    const i = Math.floor((str.length - 1) / 4);
    return Number(str.substring(0, str.length - i * 4)).toLocaleString() + units[i];
};
export function merge(obj1, obj2 = {}) {
    const nObj = {};
    for (let [key, val1] of Object.entries(obj1)) {
        const val2 = key in obj2 ? obj2[key] : null;
        if (val1 instanceof Object && val2) {
            nObj[key] = merge(val1, val2);
        }
    }
    return Object.assign(Object.assign(Object.assign({}, obj1), obj2), nObj);
}
export const validatePhoneNumber = (str) => {
    return PHONE_NUMBER_REGEX.test(str);
};
export const trimDigit = (value, length) => {
    const digit = value.replace(/\D/g, '');
    return digit.substring(0, length);
};
export const searchParams = (params) => {
    if (!params) {
        return '';
    }
    return Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}${params[key] ? `=${encodeURIComponent(params[key])}` : `${encodeURIComponent(params[key])}`}`)
        .join('&');
};
export const getQueryString = (params) => {
    const str = searchParams(params);
    return str.length ? `?${str}` : '';
};
export const parseQueryString = (search) => {
    if (!search) {
        return {};
    }
    const qs = search.replace('?', '');
    const items = qs.split('&');
    return items.reduce((data, item) => {
        const [key, value] = item.split('=');
        const [firstKey] = items[0].split('=');
        if (value) {
            data[key] = decodeURI(value.replace(/\+/g, ' '));
        }
        else {
            data[firstKey] = !item.includes('=')
                ? data[firstKey] + decodeURI(`&${item.replace(/\+/g, ' ')}`)
                : data[firstKey];
        }
        return data;
    }, {});
};
export const isNumber = (value) => !isNaN(value);
export const multiply = (num, multiple = 1) => (isNumber(num) ? num * multiple : 0);
export const sum = (...args) => args.reduce((a, b) => a + b);
export const someEqual = (acc, ...arr) => arr.some((n) => n === acc);
export const returnSwitch = (condition, trueValue, falseValue) => {
    return (condition ? trueValue : falseValue);
};
export const checkBetween = ([aStart, aEnd], [bStart, bEnd]) => {
    return !(aEnd <= bStart || aStart >= bEnd);
};
export const getBrMessage = (message) => {
    const nArray = [];
    const letter = '\n';
    nArray.push(message.split(letter)[0]);
    let br = message.indexOf(letter);
    let count = 0;
    if (br > -1) {
        while (br !== -1) {
            count++;
            nArray.push(message.split(letter)[count]);
            br = message.indexOf(letter, br + 1);
        }
    }
    return nArray;
};
export const validateCoupon = (str) => {
    return /^[A-za-z0-9]{8}$/g.test(str);
};
export const addClassToBody = (classNames) => {
    const classList = document.body.classList;
    classNames === null || classNames === void 0 ? void 0 : classNames.forEach((name) => {
        if (!classList.contains(name)) {
            document.body.classList.add(name);
        }
    });
};
export const removeClassFromBody = (classNames) => {
    const classList = document.body.classList;
    classNames === null || classNames === void 0 ? void 0 : classNames.forEach((name) => {
        if (classList.contains(name)) {
            document.body.classList.remove(name);
        }
    });
};
export const getRange = (start, count) => Array.from(Array(count)).map((_, i) => i + start);
const get32bitRandom = () => {
    var _a;
    if (typeof window !== 'undefined') {
        return Number((_a = (window.crypto || window.msCrypto)) === null || _a === void 0 ? void 0 : _a.getRandomValues(new Uint32Array(1)));
    }
    return parseInt(serverCrypto.randomBytes(4).toString('hex'), 16);
};
// Math.random 대체 (0~size(미포함)) 정수 반환
export const getRandom = (size) => {
    return Math.floor((get32bitRandom() / Math.pow(2, 32)) * size);
};
// Fisher-Yates shuffle
export const getSuffled = (arr) => {
    const result = [...arr];
    for (let i = 0; i < result.length; i++) {
        const x = getRandom(result.length - i) + i;
        [result[i], result[x]] = [result[x], result[i]];
    }
    return result;
};
export const getRandomColors = () => {
    const randoms = [
        '#9B021B,#C1201E,#894F4F,#C37F83,#CB9E47',
        '#A88977,#675D5D,#A1A01A,#7C9422,#445906',
        '#236836,#4AB18F,#227F83,#429DB0,#50859F',
        '#4B9FCF,#074458,#2445FF,#1E3866,#717198',
        '#473B61,#6F287F,#A378FC,#DE7AA6,#CB5166',
        '#231917,#25271A,#4D5954,#4F585C,#213B32',
    ];
    return getSuffled(`${randoms}`.split(','));
};
export const parseToArray = (data) => {
    if (!data) {
        return [];
    }
    return JSON.parse(data);
};
export const getCreatorPath = (item) => {
    if (item.type === 'CREATOR') {
        return `/creator/${item.uniqueValue}`;
    }
    if (item.type === 'ARTIST_MGR') {
        return `/tag?artistIds=${item.id}&title=${encodeURIComponent(item.name)}`;
    }
    if (item.type === 'CP') {
        return `/tag?contentsProviderIds=${item.id}&title=${encodeURIComponent(item.name)}`;
    }
    return '/';
};
/**
 * @param inserts 갭마다 삽입할 배열
 * @param list 갭만큼 자를 배열
 * @param gap 갭
 * @returns T[] list의 gap 마다 inserts 한 요소씩 끼워넣은 리스트 반환
 */
export const getInsertedListByGap = (inserts, list, gap) => {
    return inserts.reduce((prev, cur, index) => {
        const endIndex = index + 1 >= inserts.length ? undefined : (index + 1) * gap;
        return [...prev, cur, ...list.slice(index * gap, endIndex)];
    }, []);
};
export const sleep = (ms = 100) => new Promise((resolve) => setTimeout(() => resolve(true), ms));
